export default "__VITE_ASSET__kV_5OQSw__"